import { render } from "./DocumentList.vue?vue&type=template&id=4630f3c4&scoped=true"
import script from "./DocumentList.vue?vue&type=script&lang=ts"
export * from "./DocumentList.vue?vue&type=script&lang=ts"

import "./DocumentList.vue?vue&type=style&index=0&id=4630f3c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4630f3c4"

export default script